import { ref } from 'vue'

export type LoginPromptReason = 'reward' | 'level' | 'playtime'

export function useLoginPromptTrigger(isAdOnScreen: () => boolean) {
    const trigger = ref<{ reason: LoginPromptReason; seq: number }>()
    let pendingReason: LoginPromptReason | null = null
    let delayTimeout: ReturnType<typeof setTimeout>

    function request(reason: LoginPromptReason, delayMs = 0) {
        if (delayMs > 0) {
            clearTimeout(delayTimeout)
            delayTimeout = setTimeout(() => request(reason), delayMs)
            return
        }

        if (isAdOnScreen()) {
            pendingReason = reason
            return
        }

        trigger.value = { reason, seq: (trigger.value?.seq ?? 0) + 1 }
    }

    function flush() {
        if (pendingReason) {
            const reason = pendingReason
            pendingReason = null
            request(reason)
        }
    }

    function dispose() {
        clearTimeout(delayTimeout)
    }

    return { trigger, request, flush, dispose }
}
